module.exports = __webpack_public_path__ + "files/1269af2b98461d7e4b4d2d7080c71d68.png";